import { TOKEN_RENEW_FAILED, SIGN_IN, API_AUTHENTICATION_ERROR } from '../constants/actionTypes';

export const initialState = false;

const signedOutError = (state = initialState, action) => {
  const { type } = action;

  if (type === TOKEN_RENEW_FAILED || type === API_AUTHENTICATION_ERROR) {
    return true;
  }

  if (type === SIGN_IN) {
    return false;
  }

  return state;
};

export default signedOutError;
